import React, { Component, useEffect } from "react"
import { Col, Container, Row } from "reactstrap"

import CardUser from "./card-user"
import Earning from "./earning"
import SalesAnalytics from "./sales-analytics"
import UltimasNotasEmitidas from "./ultimas-notas-emitidas"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { registerUser, registerUserFailed } from "../../store/auth/register/actions"
import { apiError, dashboardReportLoginToken, setDashboardFilters } from "../../store/auth/login/actions"
import Loader from "react-loader-spinner"
import VendasHora from "./vendas-hora"
import VendasDia from "./vendas-dias"
import TiposPagamentos from "./tipos-pagamentos"
import GruposMaisVendas from "./grupos-mais-vendas"
import { buscarQuantidadeSolicitacoesPendentes, logoutUser } from "../../store/actions"
import UltimosMovimentoCaixaLista from "./ultimos-movimento-caixa-lista"
import { withTranslation } from "react-i18next"
import { decodeToken } from "react-jwt"
import { getPeriodsStartEndDateByType } from "../../helpers/utils"

class DashboardPadraoSemAutenticacao extends Component {

  constructor(props) {
    super(props)

    try {
      const paramsDashboardReport = this.props.match.params.hasOwnProperty("dashboardReport") ?
        this.props.match.params.dashboardReport : null
      props.dashboardReportLoginToken(paramsDashboardReport)
      const decodedToken = decodeToken(paramsDashboardReport)

      const { periodStart, periodEnd } = getPeriodsStartEndDateByType(decodedToken.periodo)
      const dateStartStr = periodStart.format("YYYY-MM-DD 00:00:00")
      const dateEndStr = periodEnd.format("YYYY-MM-DD 23:59:59")

      this.props.setDashboardFilters({
        periodStart: dateStartStr,
        periodEnd: dateEndStr,
        companiesId: [decodedToken.id]
      })
    } catch (e) {
      console.error(e)
    }
  }

  render() {

    return this.props.loadingDashboard ? (
      <div className="loader-container">
        <Loader type="ThreeDots" color="#556EE6" height={80} width={80} />
      </div>
    ) : (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>

            {/* Card User */}
            <CardUser
              {...{
                user: this.props.user,
                dashboardData: this.props.dashboardData,
                quantidadeSolicitacoesPendentes: this.props.quantidadeSolicitacoesPendentes,
                history: this.props.history
              }}
            />

            <Row>
              {/* Vendas */}
              <Earning {...{ dashboardData: this.props.dashboardData }} />

              {/* Produtos Top 10 */}
              <SalesAnalytics />
            </Row>

            <Row>
              <VendasHora></VendasHora>
              <VendasDia></VendasDia>
              <TiposPagamentos></TiposPagamentos>
              <GruposMaisVendas></GruposMaisVendas>
            </Row>

            <Row>
              <UltimosMovimentoCaixaLista />
              <UltimasNotasEmitidas {...{ dashboardData: this.props.dashboardData }}
              />
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

DashboardPadraoSemAutenticacao.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
  vinculos: PropTypes.any,
  dashboardData: PropTypes.any,
  logoutUser: PropTypes.func
}

const mapStatetoProps = state => {
  const { quantidadeSolicitacoesPendentes } = state.Profile
  const {
    loadingDashboard,
    dashboardData,
  } = state.Dashboard
  const {
    user,
    registrationError,
    dashboardReportToken
  } = state.Login
  return {
    user,
    registrationError,
    loadingDashboard,
    dashboardData,
    quantidadeSolicitacoesPendentes,
    dashboardReportToken
  }
}

export default withTranslation()(connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
  buscarQuantidadeSolicitacoesPendentes,
  logoutUser,
  setDashboardFilters,
  dashboardReportLoginToken
})(DashboardPadraoSemAutenticacao))
